import { UnitAssets, UnitsAssetsResponse } from '@marketertechnologies/property-picker';

import { queryClient } from '~/utils/queryClient';
import requestInstance from '~/utils/requestInstance';

type GetUnitsAssetsDataArgs = {
  projectUuid?: string;
  unitsUuidList?: string[];
};

export const getUnitsAssetsData = async ({
  projectUuid,
  unitsUuidList,
}: GetUnitsAssetsDataArgs): Promise<UnitsAssetsResponse> => {
  if (!projectUuid) {
    return Promise.reject(`Missing projectUuid, ${projectUuid}`);
  }

  return queryClient.fetchQuery({
    queryKey: ['units-assets', projectUuid, unitsUuidList],
    queryFn: async (): Promise<UnitsAssetsResponse> => {
      const response = await requestInstance.get(`/property_pickers/${projectUuid}/units_assets`, {
        params: {
          'units[]': unitsUuidList,
        },
      });

      const data: UnitAssets[] = response.data;

      return data
        .filter((item: UnitAssets) => Boolean(item.unit_uuid))
        .reduce(
          (acc: Record<string, UnitAssets>, item: UnitAssets) => ({
            ...acc,
            [item.unit_uuid]: item,
          }),
          {},
        );
    },
  });
};
